import axios from '../services/ApiService';
import { Document } from '../components/types/DocumentType';

export const useDocuments = () => {

    const saveDocument = async (document: Document) => {
        try {
            const formData = new FormData();
            formData.append('fileName', document.fileName);
            formData.append('purpose', document.purpose);
            formData.append('contentFile', document.contentFile);
            
            const response = await axios.post('/saveDocument', formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            });
      
            if (response.status === 200) {
              return response.data;
            } else {
              throw new Error('Failed to save document');
            }
          } catch (error) {
            throw error;
          }
    }

    const showDocument = async (docId: number) => {
        try {
            const response = await axios.get(`/getDocument/${docId}`);
            const doc: Document = response.data;
    
            // Convert base64 string to byte array if it's coming as base64
            const byteCharacters = atob(doc.contentBytes);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
    
            const blob = new Blob([byteArray], { type: doc.mimeType });
            const fileURL = URL.createObjectURL(blob);
    
            const a = document.createElement('a');
            a.href = fileURL;
            a.download = doc.fileName;
            a.target = '_blank';
            a.click();

            // Clean up
            URL.revokeObjectURL(fileURL);
        } catch (error) {
            console.error("Error fetching document", error);
            throw error;
        }
    }

    const getDocumentUrl = async (docId: number) => {
        try {
            const response = await axios.get(`/getDocument/${docId}`);
            const doc: Document = response.data;
    
            // Convert base64 string to byte array
            const byteCharacters = atob(doc.contentBytes);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
    
            const blob = new Blob([byteArray], { type: doc.mimeType });
            return URL.createObjectURL(blob);
        } catch (error) {
            console.error("Error fetching document", error);
            throw error;
        }
    }

    return {saveDocument, showDocument, getDocumentUrl}
}
